// extracted by mini-css-extract-plugin
export default {"categories":"categories_categories__yrJ7W","container":"categories_container__-Kj8B","image":"categories_image__GFGU1"};